import ItemViewModel from './ItemViewModel'

const ItemsViewModel = (items) => items.map(ItemViewModel)

export default ItemsViewModel
